import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../../../components/ui/button';
import { ReputationDefaultsDialog } from './ReputationDefaultsDialog';
import { rememberActiveGeneration } from './activeGenerationStorage';
import styles from './reputation-defaults-dialog.module.css';

export const ReputationDefaultsMenu: React.FC = () => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setDialogIsOpen(true)}>
        <Plus className={styles.triggerIcon} />
        Add default automations
      </Button>
      {dialogIsOpen && (
        <ReputationDefaultsDialog
          onClose={() => setDialogIsOpen(false)}
          onRunStarted={rememberActiveGeneration}
        />
      )}
    </>
  );
};
